import { Component, Input, OnInit } from '@angular/core';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    imports: [NgClass, DecimalPipe]
})
export class BadgeComponent implements OnInit {
  @Input() value: number;
  @Input() small: boolean;

  constructor() {}

  ngOnInit() {}
}
